
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.667 1.666H5c-.917 0-1.658.75-1.658 1.667l-.009 13.333c0 .917.742 1.667 1.659 1.667H15c.917 0 1.667-.75 1.667-1.667v-10l-5-5zm1.666 11.667h-2.5v2.5H9.167v-2.5h-2.5v-1.667h2.5v-2.5h1.666v2.5h2.5v1.667zm-2.5-5.834V2.916l4.584 4.583h-4.584z"}})])
          )
        }
      }
    